export const Limitations = [

    {
      id: 0,
      title: "Items",
      freePlandescription: "2000",
      standardPlandescription: "5000",
      proPlandescription: "-",
    },
    {
      id: 1,
      title: "Employees",
      freePlandescription: "0",
      standardPlandescription: "10",
      proPlandescription: "-",
    },
    {
      id: 2,
      title: "Warehouses",
      freePlandescription: "0",
      standardPlandescription: "5",
      proPlandescription: "-",
    },
    {
      id: 3,
      title: "Companies",
      freePlandescription: "1",
      standardPlandescription: "5",
      proPlandescription: "-",
    },
    
    
  ];
  